import { acceptedStates, negotiationStates } from '@/constants/auctionStates';

const SIDEBAR_COLLECTION_KEYS = new Set([
  'getMyNeedsFinalizing',
  'getMyNegotiations',
  'getMyActiveAuctions',
  'getWatchList',
  'getMyPendingProxies',
]);

/**
 * Returns the sidebar collection keys an auction belongs in based on its current pills
 * and other relevant properties
 */
function resolvePrimaryCollectionKey(pills, auction) {
  if (pills.includes('finalize')) return 'getMyNeedsFinalizing';
  if (pills.includes('received_last_negotiation') || pills.includes('sent_last_negotiation')) return 'getMyNegotiations';
  if (pills.includes('proxy_scheduled') && auction.status !== 'active' && auction.proxyBid?.isPersistent) return 'getMyPendingProxies';
  if (pills.includes('high_bidder') || pills.includes('out_bid')) return 'getMyActiveAuctions';
  return null;
}

function resolveSidebarCollectionKeys(auction) {
  const pills = auction.statusPills || [];

  const primaryKey = resolvePrimaryCollectionKey(pills, auction);

  const collectionKeys = primaryKey ? [primaryKey] : [];

  const currentCollectionsForAuction = (auction.includeInCollections || [])
    .map((c) => c.fetchMethod);

  // is on watchlist or was in the collection for watchlist
  if (auction.isOnWatchList || currentCollectionsForAuction.includes('getWatchList')) {
    collectionKeys.push('getWatchList');
  }

  return collectionKeys;
}

/**
 * Returns the sidebar collection keys currently assigned to an auction that are
 * not in the resolved set — i.e. keys that should be removed.
 */
function getSidebarCollectionKeysToRemove(auction, resolvedKeys) {
  const resolved = new Set(resolvedKeys);
  return (auction.includeInCollections || [])
    .map((c) => c.fetchMethod)
    .filter((k) => SIDEBAR_COLLECTION_KEYS.has(k) && !resolved.has(k));
}

/**
 * Derives sidebar-relevant statusPills from a final auction status.
 * Used by real-time end-message handlers for optimistic UI collection changes
 */
function resolveStatusPillsFromEndedStatus(status, isParticipant) {
  if (!isParticipant) return [];
  if (acceptedStates.includes(status)) return ['finalize'];
  if (negotiationStates.includes(status)) return ['received_last_negotiation'];
  return [];
}

export {
  SIDEBAR_COLLECTION_KEYS,
  resolveSidebarCollectionKeys,
  getSidebarCollectionKeysToRemove,
  resolveStatusPillsFromEndedStatus,
};
